import { EventListeners, MinzeElement } from 'minze'
import { Font } from '../../../constants'
import { Locale } from '../../../modules/locale'
import MainModule from '../../../modules/main'
import { Routing } from '../../../modules/routing'

Locale.getInstance().registerKeySet('fr', 'lvc-reminder-complete-profile-popup', {
  title: 'Compléter votre profil',
  description:
    "Recevez des recommandations d'événements qui vous correspondent vraiment. Cela ne prend que quelques instants !",
  cancel: 'Annuler',
  continue: "C'est parti !",
})

Locale.getInstance().registerKeySet('en', 'lvc-reminder-complete-profile-popup', {
  title: 'Complete your profile',
  description:
    'Get event recommendations that truly match your interests. It only takes a few moments!',
  cancel: 'Cancel',
  continue: "Let's go!",
})

export class LvcReminderCompleteProfilePopup extends MinzeElement {
  onRender(): Promise<void> | void {
    // we store that the user has seen the popup even if they just left and didn't click on anything
    sessionStorage.setItem('hasSeenCompleteProfilePopup', 'true')
  }

  onClickCancel() {
    // we store that the user has seen the popup
    // we'll only show it again if the user logs out and logs back in or clears session storage
    sessionStorage.setItem('hasSeenCompleteProfilePopup', 'true')
    this.remove()
  }

  onClickContinue() {
    // we store that the user has seen the popup
    // we'll only show it again if the user logs out and logs back in or clears session storage
    sessionStorage.setItem('hasSeenCompleteProfilePopup', 'true')
    this.remove()
    const language = Locale.language
    let mainModule = MainModule.getInstance()
    mainModule.getRouting().goTo(Routing.ROUTES[language].profile)
  }

  html() {
    return /*html*/ `
    <lvc-simple-modal id="modal" no-close-button="true">
      <div class="modal-content">
          <div class="text-section">
            <h1 class="title">${Locale.getKey('lvc-reminder-complete-profile-popup.title')}</h1>
            <h2 class="description">
              ${Locale.getKey('lvc-reminder-complete-profile-popup.description')}
            </h2>
            <lvc-charlie-hands-together-full-body></lvc-charlie-hands-together-full-body>
          </div>
          <div class="buttons-container">
            <button id="cancel-button" class="cancel-button">
            ${Locale.getKey('lvc-reminder-complete-profile-popup.cancel')}
            </button>
            <button id="continue-button" class="continue-button">
            ${Locale.getKey('lvc-reminder-complete-profile-popup.continue')}
            </button>
          </div>
      </div>
   
    </lvc-simple-modal>
    `
  }

  css = () => `
    :host {
      display: inline; 
    }

    .modal-content{
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 500px;
    }
    
    .text-section{
      display: flex;
      font-family: ${Font.family};
      color: #1E007D;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    .title{
      font-weight: ${Font.weight.extraBold};
      text-transform: uppercase;
      margin-bottom: 10px;
    }

    .description{
      font-weight: ${Font.weight.light};
      margin-bottom: 20px;
    }

    .buttons-container{
      display: flex;
      flex-direction: row;
      gap: 20px;
      justify-content: space-between;
    }

    .continue-button, .cancel-button{
      border-radius: 999px;
      color: #ffff;
      background: var(--Minuit, #1E007D);
      font-size: 16px;
      font-family: ${Font.family};
      font-style: normal;
      font-weight: 500;
      line-height: 120%;
      display: flex;
      padding: 16px 16px;
      justify-content: center;
      align-items: center;
      flex: 1 1 0;
      border: none;
      cursor: pointer;
    }

    .cancel-button{
      background: transparent;
      border: 1px solid #1E007D;
      color: #1E007D;
    }

    @media (max-width: 768px) {
      .modal-content{
        width: 100%;
      }
      .title{
        font-size: 2em;
    }
    .description{
      font-size: 1.5em;
    }
    .buttons-container{
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 0 20px;
    }
    .continue-button{
      width: 100%;
    }

    .cancel-button{
      width: 50%;
    }
  `

  eventListeners: EventListeners = [
    ['#cancel-button', 'click', this.onClickCancel.bind(this)],
    ['#continue-button', 'click', this.onClickContinue.bind(this)],
  ]
}
